import { combineReducers } from "redux";
import authReducer from "./authReducer";
import successReducer from "./successReducer";
import errorReducer from "./errorReducer";

export default combineReducers({
  auth: authReducer,
  success: successReducer,
  errors: errorReducer,
});
